import React from 'react'
import PageLayout from '../templates/PageLayout';
import './team.css';

const Member = ({person}) => {

    let picture;
    if (person.hasOwnProperty('picture'))
        picture = person.picture;
    else
        picture = 'img/profile.jpg';

    let date = "";
    if (person.hasOwnProperty('lefton'))
        date = <h6>Until:  {person.lefton}</h6>

    return (
        <li className={"memberSlot"}>
            <h4>
                {person.name + " "}
                <a href={person.url} target="_blank"><img src={"./nova-lincs-small.jpg"} alt={"novalincs"}/></a>
            </h4>
            <div style={{backgroundImage: "url('" + picture + "')"}} className="picture"/>
            <h5>{person.category}</h5>
            {date}
        </li>
    );
}

class Team extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            members: null,
        };
    }

    componentDidMount() {
        fetch('data/team/team.json')
            .then(response => response.json())
            .then(members => {
                members.sort((m0, m1) => Intl.Collator().compare(m0.name, m1.name))
                this.setState({members})
            })
            .catch(reason => console.log('Error: ' + reason));
    }

    render() {
        const members = this.state.members;
        let memberList;

        if (members == null)
            memberList = <ul className={"memberList"}></ul>;
        else
            memberList = <ul className={"memberList"}> {members.map(((member) => <Member person={member}/>))} </ul>

        return (
            <PageLayout>
                <h2>Project Team</h2>
                {memberList}
            </PageLayout>
        )
    }
}

export default Team;